import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Button } from "../components/ui/button";
import CounselingFormModal from "../components/CounselingFormModal";

const NavBar = ({ isAuthenticated }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const navbar = document.getElementById("navbarCollapse");
    if (navbar && navbar.classList.contains("show")) {
      const bsCollapse = new Bootstrap.Collapse(navbar, { toggle: false });
      bsCollapse.hide();
      setIsOpen(false);
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector(".main-nav");
      if (nav) nav.classList.toggle("ss-scrolled", window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
    const navbar = document.getElementById("navbarCollapse");
    if (navbar) {
      const bsCollapse = new Bootstrap.Collapse(navbar, { toggle: true });
      isOpen ? bsCollapse.hide() : bsCollapse.show();
    }
  };

  return (
    <>
      {/* navbar start */}
      <nav className="navbar navbar-expand-lg bg-body-white fixed-top main-nav">
        <div className="container-fluid custom_nav">
          {/* Logo on the Left */}
          <div className={`navbar-brand logo ${isOpen ? "logo-small" : ""}`}>
            <img src="/logo_up.png" alt="" />
            <span>
              <img src="Name.png" alt="" />
            </span>
          </div>
          {/* Navbar Toggler (for mobile menu) */}
          <button
            className="navbar-toggler border-0 shadow-none p-2"
            type="button"
            aria-controls="navbarCollapse"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
            style={{ background: "transparent", outline: "none" }}
          >
            <div className={`icon_mv ${isOpen ? "open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
          {/* Navbar Links in the Center */}
          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarCollapse"
          >
            <ul className="navbar-nav mx-auto">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/courses", label: "Courses" },
                { to: "/blogs", label: "Blogs" },
                { to: "/events", label: "Events" },
                { to: "/notice", label: "Notice" },
                { to: "/contact", label: "Contact" },
              ].map(({ to, label }) => {
                const active =
                  to === "/"
                    ? location.pathname === "/"
                    : location.pathname.startsWith(to);
                return (
                  <li key={to} className={`nav-item${active ? " active" : ""}`}>
                    <Link
                      className={`nav-link head-link${active ? " active" : ""}`}
                      to={to}
                    >
                      {label}
                    </Link>
                  </li>
                );
              })}
              {/* Button inside the toggle section (Mobile View) */}
              <li className="nav-item d-lg-none px-3 mt-1">
                {isAuthenticated ? (
                  <Link to="/dashboard">
                    <Button className="w-full">Dashboard</Button>
                  </Link>
                ) : (
                  <Button
                    variant="outline"
                    className="w-full"
                    onClick={() => setShowModal(true)}
                  >
                    Get Free Counseling
                  </Button>
                )}
              </li>
            </ul>
          </div>
          {/* Button on the Right (Desktop View) */}
          <div className="d-none d-lg-block">
            {isAuthenticated ? (
              <Link to="/dashboard">
                <Button>Dashboard</Button>
              </Link>
            ) : (
              <Button variant="outline" onClick={() => setShowModal(true)}>
                Get Free Counseling
              </Button>
            )}
          </div>
        </div>
      </nav>
      {/* navbar end */}
      <CounselingFormModal
        open={showModal}
        onClose={() => setShowModal(false)}
        title="Get Free Counseling"
      />
    </>
  );
};
export default NavBar;
